import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '@tekion/tmatter';
import { EMPTY_STRING, SINGLE_SPACE, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import NoteText from './NoteText';
import { translateUserMentionedToJSX } from '../Note.helpers';
var EditedLabel = function EditedLabel() {
  return /*#__PURE__*/React.createElement(Label, {
    type: "assistive",
    color: "ashGrey",
    block: false
  }, __('(Edited)'));
};
var NoteDisplay = function NoteDisplay(_ref) {
  var note = _ref.note,
    isEdited = _ref.isEdited,
    className = _ref.className,
    enableMentions = _ref.enableMentions,
    associatedUsers = _ref.associatedUsers;
  var noteText = enableMentions ? translateUserMentionedToJSX(note, associatedUsers) : note;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(NoteText, null, noteText), SINGLE_SPACE, isEdited && /*#__PURE__*/React.createElement(EditedLabel, null));
};
NoteDisplay.propTypes = {
  note: PropTypes.string,
  isEdited: PropTypes.bool,
  className: PropTypes.string,
  enableMentions: PropTypes.bool,
  associatedUsers: PropTypes.object
};
NoteDisplay.defaultProps = {
  note: EMPTY_STRING,
  isEdited: false,
  className: '',
  enableMentions: false,
  associatedUsers: EMPTY_OBJECT
};
export default NoteDisplay;